var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"value":_vm.authModal.open,"max-width":"556px"},on:{"input":_vm.closeModal}},[_c(_vm.currentComponent,{tag:"component",on:{"change":_vm.changeModalType,"sent":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }